import { MessageCommandData } from 'interfaces/MessageData';

export const enum CommandActionType {
    Send = 'COMMAND/SEND',
    Receive = 'COMMAND/RECEIVE',
}

export type ReceiveCommandAction = ReturnType<typeof receiveCommand>;
export const receiveCommand = (command: MessageCommandData) => ({
    type: CommandActionType.Receive,
    payload: command,
});

export type SendCommandAction = ReturnType<typeof sendCommand>;
export const sendCommand = (command: MessageCommandData) => ({
    type: CommandActionType.Send,
    payload: command,
});
